module.exports = __webpack_public_path__ + "fonts/typicons.29f9630f7d87a79830d1c321e1600f2e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/typicons.ttf
// module id = 404
// module chunks = 0